import { LevelCard } from '@/widgets/VerificationAddOns';
import { softwareEscrowAddonsDictionary, AddOnTypeEnum } from 'src/shared/entities/verification-addons';

import GetAddOnAction from './GetAddOnAction';
import RequestCertifiedAction from './RequestCertifiedAction';

const ReportsEnablingContainer = () => {
  return (
    <div className="flex flex-col md:flex-row md:justify-center gap-4 lg:gap-16 lg:px-10">
      <LevelCard
        {...softwareEscrowAddonsDictionary[AddOnTypeEnum.VERIFIED]}
        actionNode={<GetAddOnAction />}
        className="max-w-[416px] mx-auto lg:mx-0"
      />
      <LevelCard
        {...softwareEscrowAddonsDictionary[AddOnTypeEnum.CERTIFIED]}
        actionNode={<RequestCertifiedAction />}
        className="max-w-[416px] mx-auto lg:mx-0"
      />
    </div>
  );
};

export default ReportsEnablingContainer;
